/**
 * SEC Form 13F reports calendar-quarter positions as of quarter-end.
 * Map fiscal quarter labels to the month the snapshot represents.
 */
const CALENDAR_Q_TO_MONTH: Record<string, string> = {
  '1': 'Mar',
  '2': 'Jun',
  '3': 'Sep',
  '4': 'Dec',
};

/**
 * Accepts backend keys (`YYYY-Qn`) or display labels (`Qn YYYY`) and returns
 * a short month + year (e.g. `Dec 2025`).
 */
export function formatInstitutionalSnapshotPeriod(input: string): string {
  const key = input.match(/^(\d{4})-Q([1-4])$/);
  if (key) {
    const mon = CALENDAR_Q_TO_MONTH[key[2]!];
    return mon ? `${mon} ${key[1]}` : input;
  }
  const label = input.match(/^Q([1-4])\s+(\d{4})$/);
  if (label) {
    const mon = CALENDAR_Q_TO_MONTH[label[1]!];
    return mon ? `${mon} ${label[2]}` : input;
  }
  return input;
}
